// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_np-0";
export var discountCodeInput = "_np-1";